(function (skyward, $, undefined)
{
    skyward.massaddspecialprogramstx = skyward.massaddspecialprogramstx || {};

    var massAddSpecialProgramsTXWorkflowSelector, atRisk, campIDOfAcct, campIDOfRes, cte, crisis, dyslexia, earlyReading, fosterCare, giftedTalented, graduationProgramEndorsement, homeboundhospital, homeless,
        immigrant, lep, migrant, militaryConnectedStudent, pregnancyEducationParenting, pregRelService, preK, ssiProRet, includeExclude, stuAttr, workflowInstanceId;

    var init = function (selector)
    {
        "use strict";
        
        massAddSpecialProgramsTXWorkflowSelector = $(selector).find("#SpecialProgramsContainer");
        if (massAddSpecialProgramsTXWorkflowSelector.length > 0)
        {
            workflowInstanceId = $('.workflow.skywardContentPanel').data('workflow-instance-id');
            //Individual Special Program Wrapper functions
            $(function ()
            {
                $("input, textarea").on('errorChange', function ()
                {
                    if ($(this).hasClass('error-control'))
                    {
                        if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').toggleClass('error-control');
                        }
                    }
                    else
                    {
                        if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                        {
                            if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                            {
                                $(this).closest('.specialProgramContainer').removeClass('error-control');
                            }
                        }
                    }
                });
            });

            registerContainers();
        }
        else
        {
            return;
        }
    };

    var registerContainers = function ()
    {
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            specialProgram.checkBox = specialProgram.find('input.specialProgramCheckBox:checkbox');
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                specialProgram.fieldsContainer = specialProgram.find('.fieldWrapper');
                specialProgram.buttonDiv = specialProgram.find('.specialProgramButtonDiv');
                specialProgram.expandButton = specialProgram.find('#expandButton');
                specialProgram.collapseButton = specialProgram.find('#collapseButton');
                specialProgram.checkBox.change(function ()
                {
                    skyward.massaddspecialprogramstx.isProgramChecked();
                });
                specialProgram.buttonDiv.click(function ()
                {
                    skyward.massaddspecialprogramstx.expandCollapse();
                });
            }
        }
    };

    skyward.massaddspecialprogramstx.isProgramChecked = function ()
    {
        var target = $(event.target);
        var isChecked = target.prop('checked');
        var wrapper = target.closest('.specialProgramContainer').find('.fieldWrapper.specialProgramsFields');

        if (isChecked) 
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else 
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.find('input, textarea').each(function ()
            {
                skyward.controls.setValue($(this), '');
            });
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.closest('.specialProgramContainer').removeClass("specialProgramError");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.expandCollapse = function ()
    {
        var target = $(event.target);
        var wrapper = target.closest('.specialProgramContainer').find('.fieldWrapper.specialProgramsFields');
        var isHidden = wrapper.hasClass('collapsed');


        if (isHidden)
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.parseXML = function ()
    {
        var xmlDoc = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "SpecialProgramParameters", null);
        var specialProgramParametersXML = xmlDoc.createElement("SpecialProgramParameters");
        var parseSectionXML = function (specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                $(specialProgram).find("input:not(.distinctMultiSelectUserInput), textarea, select").each(function ()
                {
                    var fieldValue, fieldNameNode, fieldValueNode;
                    var field = $(this);
                    var fieldID = field.prop('id');

                    if (field.is(':checkbox'))
                    {
                        fieldValue = field.prop('checked');
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('dmsBackingData'))
                    {
                        fieldValue = skyward.distinctMultiSelectEEL.values.get(field);
                        fieldNameNode = xmlDoc.createElement(fieldID);

                        for (var key in fieldValue)
                        {
                            if (fieldValue.hasOwnProperty(key))
                            {
                                var selectedNode = xmlDoc.createElement('DMSSelectedNode');
                                fieldValueNode = xmlDoc.createTextNode(key);
                                selectedNode.appendChild(fieldValueNode);
                                fieldNameNode.appendChild(selectedNode);
                            }
                        }
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('comboBoxSet'))
                    {
                        fieldValue = field.val();
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else
                    {
                        fieldValue = field.prop('value');
                        if (fieldID.indexOf('_code') < 0 && fieldID.indexOf('_description') < 0)
                        {
                            if (fieldID.indexOf('_value') > -1)
                            {
                                fieldID.replace('_value', '');
                            }

                            fieldNameNode = xmlDoc.createElement(fieldID);
                            fieldValueNode = xmlDoc.createTextNode(fieldValue);
                            fieldNameNode.appendChild(fieldValueNode);
                            specialProgramNode.appendChild(fieldNameNode);
                        }
                    }
                });
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };

        var parseSingleElementXML = function(specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };
       
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                parseSectionXML(specialProgram);
            }
            else
            {
                parseSingleElementXML(specialProgram);
            }
        }

        $.ajax(
        {
            url: skyward.global.virtualDir + 'SpecialPrograms/TempMassCreateEndSpecialProgramTX/ValidateXML',
            type: "POST",
            datatype: "JSON",
            data:
            {
                workflowInstanceId: workflowInstanceId,
                SpecialProgramsXML: encodeURIComponent((new XMLSerializer()).serializeToString(specialProgramParametersXML))
            },
            success: function (data)
            {
                if (data.success)
                {
                    skyward.buttonManager.manageButtonClick(skyward.workflow.customButtonAction('customNext'));
                }
                else
                {
                    if (!$.isEmptyObject(data.errors))
                    {
                        var container = $('#SpecialProgramsContainer');
                        var baseErrorContainer = container.find(".contentMessageArea");

                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }

                //Because of custom javascript need to handle the ajax update
                var updates = data.Update || {};

                for (field in updates)
                {
                    var nameElement = $("[name='" + field + "']");
                    skyward.controls.setValue(nameElement, updates[field]);
                }
            }
        });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);